module.exports = __webpack_public_path__ + "img/male-adult-foot.6597a856.svg";